<div [class]="currentBrand">
    <ion-router-outlet></ion-router-outlet>
</div>
